<div class="chain-update"
     [ngClass]="{ 'chain-update-has-comment': chainUpdate.hasComment }">
    <adapt-person-image class="chain-update-person"
                        [ngClass]="{
            'with-comment': chainUpdate.hasComment,
            'without-comment': !chainUpdate.hasComment,
        }"
                        [person]="chainUpdate.person"></adapt-person-image>
    <div class="chain-update-container">
        <div class="chain-update-meta">
            <adapt-link-person [person]="chainUpdate.person"></adapt-link-person>
            <adapt-entity-timestamp class="chain-update-date-time"
                                    [timestamp]="chainUpdate.dateTime"></adapt-entity-timestamp>
            @if (chainUpdate.canUpdate) {
                <span class="chain-update-editing-buttons">
                    <button adaptButtonIcon="edit"
                            class="btn btn-link"
                            (click)="itemEdited.emit(chainUpdate)"></button>
                    <button adaptButtonIcon="delete"
                            class="btn btn-link"
                            (click)="itemDeleted.emit(chainUpdate)"></button>
                </span>
            }
        </div>
        <div class="chain-update-text">
            @if (chainUpdate.iconClass) {
                <i aria-hidden="true"
                   class="chain-update-icon"
                   [ngClass]="chainUpdate.iconClass"></i>
            }
            <span>{{ chainUpdate.text }}</span>
        </div>
    </div>
</div>
